import React from 'react'

import { Icon } from '@clientbase/clientbase-library'
import { IconButton, Tooltip } from '@mui/material'

interface Props {
  onClick: (e: React.MouseEvent<HTMLElement>) => void
  active?: boolean
  hiddenOnMobile?: boolean
}

const ColumnSelectorTrigger: React.FC<Props> = ({
  onClick,
  active,
  hiddenOnMobile
}) => {
  return (
    <Tooltip title="Configurar tabela" placement="top">
      <IconButton
        aria-label="Configurar tabela"
        aria-pressed={active ? 'true' : 'false'}
        size="small"
        onClick={(e) => {
          e.stopPropagation()
          onClick(e)
        }}
        sx={{
          width: 28,
          height: 28,
          color: active ? 'primary.main' : 'neutral.darker',
          ...(hiddenOnMobile && { display: { xs: 'none', md: 'inline-flex' } })
        }}
      >
        <Icon icon="web" sx={{ fontSize: 18 }} />
      </IconButton>
    </Tooltip>
  )
}

export default ColumnSelectorTrigger
